import { render, staticRenderFns } from "./SuiteTabs.vue?vue&type=template&id=3692d0a8&scoped=true"
import script from "./SuiteTabs.vue?vue&type=script&lang=js"
export * from "./SuiteTabs.vue?vue&type=script&lang=js"
import style0 from "./SuiteTabs.vue?vue&type=style&index=0&id=3692d0a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3692d0a8",
  null
  
)

export default component.exports